{
    "regionsSelectable":    false,
    "regionsSelectableOne": false,
    "regionStyle": {
        "initial": {
            "fill":             "#076cb3",
            "stroke":           "#83afd5",
            "strokeWidth":      1,
            "fillOpacity":      1
        },
        "hover": {
            "fill":             "#62b42c"
        },
        "selected": {
            "fill":             "#62b42c"
        }
    },
    "regionLabelStyle": {
        "initial": {
            "fill":       "#fff",
            "fontFamily": "Noto Sans JP",
            "fontWeight": 500,
            "fontSize":   15
        },
        "hover": {},
        "selected": {},
        "selectedHover": {}
    },
    "series": {
        "attribute": "fill"
    }
}
